@if (this.open()) {
  <ta-layout-full-panel
    width="520px"
    class="incomplete-profile"
    [title]="'app.base.modal.incomplete_profile.profile_update_required'"
    (closeEvent)="this.handleClose()"
  >
    <div panel-content class="flex-column g-space-md">
      <!-- La seule sortie possible est la déconnexion. -->
      <ta-button
        class="logout-action"
        type="secondary"
        size="small"
        icon="logout"
        [options]="{ square: 'small' }"
        (action)="this.logout()"
      ></ta-button>
      <ta-overline size="sm" tone="muted">{{
        'app.base.modal.incomplete_profile.title' | translate
      }}</ta-overline>
      <ta-text>
        {{ 'app.base.modal.incomplete_profile.description' | translate }}
      </ta-text>

      <ta-menu-navigation container="tab" [menu]="this.tabMenu.getMenu()"></ta-menu-navigation>

      <!-- Infos personnelles : pour un particulier, et pour un représentant invité. -->
      @if (this.activeTab() === 'private' || this.membership()) {
        <ta-form
          [inputs]="this.form()"
          [loader]="this.requestState.isLoading()"
          [canDisplayButton]="false"
          [askValidation$]="this.askValidation$"
          (valid)="this.onSave($event)"
        ></ta-form>
      }

      @if (this.activeTab() === 'private') {
        <app-role-selection
          [showTitle]="true"
          (roleChange)="this.onRoleChange($event)"
        ></app-role-selection>
      }

      @if (this.activeTab() === 'pro') {
        @if (this.membership(); as membership) {
          <ta-text>
            {{
              'app.base.modal.incomplete_profile.joining_company'
                | translate: { company: membership.company?.name }
            }}
          </ta-text>
        } @else {
          <ta-banner
            [inline]="true"
            type="warning"
            [message]="'app.base.modal.incomplete_profile.company_hint'"
          ></ta-banner>
          <ta-form
            [inputs]="this.companyForm()"
            [loader]="this.requestState.isLoading()"
            [canDisplayButton]="false"
            [askValidation$]="this.askCompanyValidation$"
            (valid)="this.onSaveCompany($event)"
          ></ta-form>
        }
      }

      <ta-checkbox [checked]="this.cguAccepted()" (checkedChange)="this.cguAccepted.set($event)">
        {{ 'app.base.modal.incomplete_profile.cgu_accept' | translate }}
        <a class="cgu-link" (click)="this.openCgu(); $event.stopPropagation()">
          {{ 'app.base.modal.incomplete_profile.cgu_link' | translate }}
        </a>
      </ta-checkbox>

      <div class="submit flex-column g-space-sm">
        @if (this.submitHint(); as hint) {
          <ta-text size="sm" class="submit-hint">{{ hint | translate }}</ta-text>
        }

        @if (this.activeTab() === 'private') {
          <ta-button
            [state]="this.canSubmit() ? 'classic' : 'disabled'"
            size="small"
            (action)="this.onSubmit()"
          >
            {{ 'app.base.modal.incomplete_profile.confirm_button' | translate }}
          </ta-button>
        } @else {
          <ta-button
            [state]="this.canSubmitPro() ? 'classic' : 'disabled'"
            size="small"
            (action)="this.onSubmitPro()"
          >
            {{ 'app.base.modal.incomplete_profile.confirm_button' | translate }}
          </ta-button>
        }
      </div>
    </div>
  </ta-layout-full-panel>
}
